import { render, staticRenderFns } from "./EmployeeDetailsEditor.vue?vue&type=template&id=3268e74c&scoped=true&"
import script from "./EmployeeDetailsEditor.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailsEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDetailsEditor.vue?vue&type=style&index=0&id=3268e74c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3268e74c",
  null
  
)

export default component.exports